import { useState } from 'react';

const useHamburgerMenu = () => {
  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);

  const toggleHamburgerMenu = () => {
    setIsHamburgerMenuOpen(prevState => !prevState);
  };

  return {
    isHamburgerMenuOpen,
    toggleHamburgerMenu,
    closeHamburgerMenu: () => setIsHamburgerMenuOpen(false),
  };
};

export default useHamburgerMenu;
